import angular from "angular";

export class ChatHubspotService {
    constructor() {
        this.openned = false;
    }

    open() {
        this.openned = true;
        window.HubSpotConversations.widget.open();
    }

    toMaintain() {
        const body = angular.element(document.querySelector("body"));

        if (!this.openned) return body.removeClass("overwrite-chat-rules");

        window.HubSpotConversations.widget.open();
        this.openned = false;
    }

    hide() {
        const body = angular.element(document.querySelector("body"));
        body.addClass("hide-chat-module");
    }

    show() {
        const body = angular.element(document.querySelector("body"));
        body.removeClass("hide-chat-module");
    }
}

angular.module("nucont.shared").service("ChatHubsbotService", [ChatHubspotService]);
